export const FONT_OPTIONS = [
  {
    label: "Inter",
    value: "'Inter', sans-serif",
    google: "Inter:wght@400;500;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap",
  },
  {
    label: "Roboto",
    value: "'Roboto', sans-serif",
    google: "Roboto:wght@400;500;700",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap",
  },
  {
    label: "Open Sans",
    value: "'Open Sans', sans-serif",
    google: "Open+Sans:wght@400;600;700",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap",
  },
  {
    label: "Poppins",
    value: "'Poppins', sans-serif",
    google: "Poppins:wght@400;500;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap",
  },
  {
    label: "Montserrat",
    value: "'Montserrat', sans-serif",
    google: "Montserrat:wght@400;500;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap",
  },
  {
    label: "Lato",
    value: "'Lato', sans-serif",
    google: "Lato:wght@400;700",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap",
  },
  {
    label: "Nunito",
    value: "'Nunito', sans-serif",
    google: "Nunito:wght@400;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Nunito:wght@400;600&display=swap",
  },
  {
    label: "Source Sans 3",
    value: "'Source Sans 3', sans-serif",
    google: "Source+Sans+3:wght@400;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@400;600&display=swap",
  },
  {
    label: "Playfair Display",
    value: "'Playfair Display', serif",
    google: "Playfair+Display:wght@400;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600&display=swap",
  },
  {
    label: "Manrope",
    value: "'Manrope', sans-serif",
    google: "Manrope:wght@400;500;600;700",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=swap",
  },
  {
    label: "Raleway",
    value: "'Raleway', sans-serif",
    google: "Raleway:wght@400;500;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap",
  },
  {
    label: "DM Sans",
    value: "'DM Sans', sans-serif",
    google: "DM+Sans:wght@400;500;700",
    importUrl:
      "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap",
  },
  {
    label: "Work Sans",
    value: "'Work Sans', sans-serif",
    google: "Work+Sans:wght@400;500;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;500;600&display=swap",
  },
  {
    label: "Karla",
    value: "'Karla', sans-serif",
    google: "Karla:wght@400;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Karla:wght@400;600&display=swap",
  },
  {
    label: "Nunito Sans",
    value: "'Nunito Sans', sans-serif",
    google: "Nunito+Sans:wght@400;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600&display=swap",
  },
  {
    label: "PT Sans",
    value: "'PT Sans', sans-serif",
    google: "PT+Sans:wght@400;700",
    importUrl:
      "https://fonts.googleapis.com/css2?family=PT+Sans:wght@400;700&display=swap",
  },
  {
    label: "Oswald",
    value: "'Oswald', sans-serif",
    google: "Oswald:wght@400;500;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600&display=swap",
  },
  {
    label: "Space Grotesk",
    value: "'Space Grotesk', sans-serif",
    google: "Space+Grotesk:wght@400;500;600",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600&display=swap",
  },
  {
    label: "Merriweather",
    value: "'Merriweather', serif",
    google: "Merriweather:wght@400;700",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Merriweather:wght@400;700&display=swap",
  },
  {
    label: "Libre Baskerville",
    value: "'Libre Baskerville', serif",
    google: "Libre+Baskerville:wght@400;700",
    importUrl:
      "https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&display=swap",
  },
];

export const DEFAULT_FONT = FONT_OPTIONS.find(f => f.label === 'DM Sans') || FONT_OPTIONS[0];

export const findFontConfig = (fontValue) =>
  FONT_OPTIONS.find((option) => option.value === fontValue) || null;

